module.exports = __webpack_public_path__ + "2e771ecb917e1c36692b63e3d1ef4af1.png";